$(document).ready(function ()
{
    NL.storepickup.init();
});


"use strict"
var NL = (typeof NL === 'object') ? NL : {};
NL.storepickup = {
    VAR: {

    },
    init: function () {
        var _this = this;
        // _this.addItem(current_variant_id);
        // $('html').addClass('st-pick');
        $('body').on('click', '.close-wrap .closesize, .mini-cart-back', function (e) {
            e.preventDefault();
            $('html').removeClass('st-pick');
        });

        $('body').on('click', '.fis-btn:not(.cartnewclick)', function (e) {

            e.preventDefault();
            _this.addItem($('[data-product-select]').val());
        });

        $('body').on('click', '.pa-listing .cover, .pa-listing .avail', function (e) {
            e.preventDefault();
            $(this).parents('.pa-listing').find('.ac-title').trigger('click');
        });
    },

    addItem: function (id) {
    var _this = this;
        const variantSectionUrl = '/variants/'+id+'/?section_id=pickup-availability-new';

        $.get(variantSectionUrl, function (data) {

           $('.pickup-loader').html(data);
           $('html').addClass('st-pick');

        }).done(function () {
        });
},

};
